import React, { useEffect, useState } from "react";
import styled from "styled-components";
import LinearProgress from "@material-ui/core/LinearProgress";
// layout
import { colors } from "../layout/constants";

let timeLimit;
const ProgressBar = ({
  hasVideo,
  totalQuestions,
  answredQuestions,
  sendAnswer,
  activeQuestion,
  selectQuestion,
  resetTimer,
  questions,
  sendingQuestion,
  choiceID
}) => {
  const [timerLocal, setTimerLocal] = useState(90);

  useEffect(() => {
    selectQuestion();
  }, []);

  useEffect(() => {
    if (timerLocal > 0 && hasVideo && !resetTimer) {
      clearTimeout(timeLimit);
      timeLimit = setTimeout(() => {
        setTimerLocal(timerLocal - 1);
      }, 1000);
    } else if (hasVideo && !resetTimer) {
      if (questions.length) {
        clearTimeout(timeLimit);
        sendAnswer(activeQuestion, choiceID, "Time expired");
      }
    }
  }, [timerLocal, hasVideo]);



  useEffect(() => {
    if (resetTimer) {
      clearTimeout(timeLimit);
      setTimerLocal(90);
    }
  }, [resetTimer]);

  return (
    <ProgressStyled>
      <div className="div-progressbar">
        <div className="test-status">
          <p className="status-text">
            Pregunta <span className="highlight-text">{answredQuestions}</span> de{" "}
            <span className="highlight-text">{totalQuestions}</span> {" "}
            (Quedan <span className="highlight-text">{timerLocal}</span> segundos)
          </p>
        </div>
        <div className="status-bar">
          <LinearProgress
            variant="determinate"
            value={((answredQuestions - 1) / totalQuestions) * 100}
          />
          <p className="percentage">
            {(((answredQuestions - 1) / totalQuestions) * 100).toFixed(1)}%
        </p>
        </div>
      </div>
    </ProgressStyled>
  );
};

const ProgressStyled = styled.section`
  .div-progressbar{
    width: 100%;
    margin: 0 auto;
  }
  .test-status {
    display: flex;
    font-size: 1rem;
    justify-content: space-between;
  }

  .status-text {
    margin: 20px 0;
  }

  .highlight-text {
    font-weight: 600;
  }

  .status-bar {
    position: relative;
  }

  .percentage {
    font-size: 0.6rem;
    font-style: italic;
    font-weight: 600;
    margin: 0 auto;
    position: absolute;
    top: 0.3em;
    width: 100%;
  }

  .MuiLinearProgress-root {
    border-radius: 4px;
    height: 1rem;
  }

  .MuiLinearProgress-barColorPrimary {
    background-color: ${colors.secondary};
  }

  .MuiLinearProgress-colorPrimary {
    background-color: ${colors.backgroundDark};
  }

  @media (max-width: 460px) {
    .test-status {
      flex-direction: column;
      justify-content: flex-start;
    }

    .status-text {
      text-align: left;
    }
  }
`;

export default ProgressBar;
